(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nooves-compare-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(box) {
      if (box.getAttribute('data-nv-ready')) return;
      box.setAttribute('data-nv-ready', '1');
      var hint = box.parentNode.querySelector('[data-nv-cmp-hint]');
      var down = false, startX = 0, startLeft = 0;
      function overflow() { return box.scrollWidth - box.clientWidth > 4; }
      function refresh() {
        var o = overflow();
        box.classList.toggle('nv-cmp--can', o);
        if (hint) { hint.hidden = !(o && !box.getAttribute('data-nv-moved')); }
      }
      box.addEventListener('scroll', function () {
        if (box.scrollLeft > 4 && !box.getAttribute('data-nv-moved')) {
          box.setAttribute('data-nv-moved', '1');
          if (hint) hint.hidden = true;
        }
      }, { passive: true });
      box.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || !overflow()) return;
        down = true; startX = e.clientX; startLeft = box.scrollLeft;
        box.classList.add('nv-cmp--drag');
        try { box.setPointerCapture(e.pointerId); } catch (err) {}
      });
      box.addEventListener('pointermove', function (e) {
        if (!down) return;
        box.scrollLeft = startLeft - (e.clientX - startX);
      });
      function end(e) {
        if (!down) return;
        down = false;
        box.classList.remove('nv-cmp--drag');
        try { box.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      box.addEventListener('pointerup', end);
      box.addEventListener('pointercancel', end);
      box.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        if (!overflow()) return;
        var cell = box.querySelector('tbody td');
        var step = cell ? cell.getBoundingClientRect().width : 160;
        box.scrollBy({ left: e.key === 'ArrowRight' ? step : -step });
        e.preventDefault();
      });
      window.addEventListener('resize', refresh);
      refresh();
    }
    function run() { document.querySelectorAll('[data-nv-cmp]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nooves-lp-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__nvLpsInit) return;
    window.__nvLpsInit = true;
    function init() {
      var bars = document.querySelectorAll('[data-nv-lps]');
      Array.prototype.forEach.call(bars, function (bar) {
        bar.removeAttribute('hidden');
        var targetSel = bar.getAttribute('data-hide-on');
        var target = null;
        try { target = targetSel ? document.querySelector(targetSel) : null; } catch (e) {}
        if (!target) target = document.querySelector('[data-nv-lp-final]');
        var pastHero = false;
        var overFinal = false;
        function update() { bar.classList.toggle('is-visible', pastHero && !overFinal); }
        function onScroll() {
          pastHero = window.scrollY > Math.max(320, window.innerHeight * 0.6);
          update();
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        if (target && 'IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            overFinal = entries[0].isIntersecting;
            update();
          }, { threshold: 0.05 }).observe(target);
        }
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nooves-welcome-popup"]) return;
  try {
    
  (function () {
    if (window.__nvWpInit) return;
    window.__nvWpInit = true;

    var T = {
      en: {
        close: 'Close', q1_eyebrow: 'For your first order', q1_title: 'What are you up to?',
        q1_sub: 'Two taps and we show you your {discount} off.',
        q1_opt_laminas: 'Gel nail strips', q1_opt_ext: 'Gel Extensions', q1_opt_looking: 'Still browsing',
        q1_decline: 'My nails can wait',
        lamp_title: 'Do you already have a UV/LED lamp?', lamp_yes: 'Yes', lamp_no: 'Not yet',
        exp_title: 'What have you tried before?', exp_press: 'Press-on', exp_nooves: 'NOOVES gel strips', exp_none: 'Nothing yet',
        msg_press: 'From press-on to extensions is one step. Real semi-cured gel with its own adhesive, no extra glue.',
        msg_nooves: 'Extensions are the next level: same real semi-cured gel, more length, shaped with the Shaping Lamp.',
        msg_none: 'Easier than it looks: on in 10 to 15 minutes, depending on your practice.',
        email_title: 'Your first order, {discount} off', email_text: 'Leave your email and we show you your code.',
        email_label: 'Email', consent_label: 'I want to receive NOOVES news and offers by email. You can unsubscribe any time.',
        privacy_label: 'Privacy policy', submit: 'Show my code', sending: 'Sending...', no_thanks: 'No, thanks',
        err_email: 'Enter a valid email.', err_net: 'Something went wrong. Try again.',
        done_title: 'Here is your code', done_consent: 'We also sent it to your email.',
        done_noconsent: 'Use it on your first order. The button below applies it for you.', done_failed: 'Save it: this is your code for your first order.',
        code_label: 'Your code', copy: 'Copy', copied: 'Copied',
        cta_laminas: 'See gel nail strips', cta_ext: 'See Gel Extensions'
      },
      'pt-PT': {
        close: 'Fechar', q1_eyebrow: 'Para a tua primeira encomenda', q1_title: 'O que andas a preparar?',
        q1_sub: 'Dois toques e mostramos-te o teu desconto de {discount}.',
        q1_opt_laminas: 'Folhas de gel', q1_opt_ext: 'Extensões de gel', q1_opt_looking: 'Ainda estou a ver',
        q1_decline: 'As minhas unhas podem esperar',
        lamp_title: 'Já tens candeeiro UV/LED?', lamp_yes: 'Sim', lamp_no: 'Ainda não',
        exp_title: 'O que já experimentaste?', exp_press: 'Press-on', exp_nooves: 'Folhas de gel NOOVES', exp_none: 'Nada ainda',
        msg_press: 'Do press-on às extensões vai um passo. Gel real semicurado com adesivo próprio, sem cola à parte.',
        msg_nooves: 'As extensões são o nível seguinte: o mesmo gel real semicurado, mais comprimento, moldado com o Candeeiro de Moldagem.',
        msg_none: 'Mais fácil do que parece: aplicam-se em 10 a 15 minutos, conforme a tua prática.',
        email_title: 'A tua primeira encomenda, com {discount} de desconto', email_text: 'Deixa o teu email e mostramos-te o teu código.',
        email_label: 'Email', consent_label: 'Quero receber novidades e ofertas da NOOVES por email. Podes cancelar quando quiseres.',
        privacy_label: 'Política de privacidade', submit: 'Ver o meu código', sending: 'A enviar...', no_thanks: 'Não, obrigada',
        err_email: 'Introduz um email válido.', err_net: 'Algo correu mal. Tenta de novo.',
        done_title: 'Aqui tens o teu código', done_consent: 'Também to enviámos por email.',
        done_noconsent: 'Usa-o na tua primeira encomenda. O botão abaixo aplica-o por ti.', done_failed: 'Guarda-o: é o teu código para a primeira encomenda.',
        code_label: 'O teu código', copy: 'Copiar', copied: 'Copiado',
        cta_laminas: 'Ver folhas de gel', cta_ext: 'Ver extensões de gel'
      }
    };

    var DISMISS_KEY = 'nv_wp_dismissed';
    var DONE_KEY = 'nv_wp_done';
    var SEEN_KEY = 'nv_wp_seen';

    function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
    function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
    function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
    function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
    function track(step, extra) {
      try {
        var o = { event: 'nv_welcome_popup', nv_wp_step: step };
        if (extra) for (var k in extra) o[k] = extra[k];
        (window.dataLayer = window.dataLayer || []).push(o);
      } catch (e) {}
    }
    function klaviyoKnowsEmail() {
      try {
        var m = document.cookie.match(/(?:^|; )__kla_id=([^;]+)/);
        if (!m) return false;
        var j = JSON.parse(atob(decodeURIComponent(m[1])));
        return !!(j && j.$email);
      } catch (e) { return false; }
    }

    function init(root) {
      var cfgEl = root.querySelector('[data-nv-wp-config]');
      if (!cfgEl) return;
      var cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

      var loc = (cfg.locale || 'es').toLowerCase();
      var dict = cfg.es;
      if (loc.indexOf('pt') === 0) dict = T['pt-PT'];
      else if (loc.indexOf('en') === 0) dict = T.en;
      var isEs = dict === cfg.es;
      function tx(key) {
        var s = (dict && dict[key]) || cfg.es[key] || '';
        return s.replace(/\{discount\}/g, (cfg.discount || '').split(' ').join(String.fromCharCode(160)));
      }

      var card = root.querySelector('.nv-wp__card');
      var steps = root.querySelectorAll('.nv-wp__step');
      var dots = root.querySelectorAll('.nv-wp__dots i');
      var form = root.querySelector('[data-nv-wp-form]');
      var err = root.querySelector('[data-nv-wp-error]');
      var state = { interest: '', experience: '', lamp: '' };
      var opener = null;
      var forced = /[?&]nv_wp=1/.test(window.location.search);

      Array.prototype.forEach.call(root.querySelectorAll('[data-t]'), function (el) {
        el.textContent = tx(el.getAttribute('data-t'));
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-t-aria]'), function (el) {
        el.setAttribute('aria-label', tx(el.getAttribute('data-t-aria')));
      });

      var order = ['q1'].concat(cfg.q2 ? ['q2'] : []).concat(['email', 'done']);

      /* 2.ª pregunta condicional: láminas pregunta por la lámpara, extensiones por la experiencia */
      function setupQ2() {
        var isExt = state.interest === 'extensiones';
        var keys = isExt ? ['exp_press', 'exp_nooves', 'exp_none'] : ['lamp_yes', 'lamp_no'];
        var vals = isExt ? ['press_on', 'laminas_nooves', 'nada'] : ['si', 'no'];
        var t = root.querySelector('[data-q2-title]');
        if (t) t.textContent = tx(isExt ? 'exp_title' : 'lamp_title');
        Array.prototype.forEach.call(root.querySelectorAll('[data-q2-opt]'), function (b, i) {
          b.hidden = i >= keys.length;
          b.classList.remove('is-selected');
          if (i < keys.length) {
            b.setAttribute('data-answer2', vals[i]);
            b.querySelector('.nv-wp__opt-label').textContent = tx(keys[i]);
          }
        });
      }

      function go(name) {
        Array.prototype.forEach.call(steps, function (s) { s.hidden = s.getAttribute('data-step') !== name; });
        var idx = order.indexOf(name);
        Array.prototype.forEach.call(dots, function (d, i) { d.classList.toggle('is-on', i <= idx); });
        var title = root.querySelector('[data-step="' + name + '"] .nv-wp__title');
        if (title) {
          if (!title.id) title.id = 'nv-wp-t-' + name;
          card.setAttribute('aria-labelledby', title.id);
        }
        card.scrollTop = 0;
        track('step_' + name, { nv_wp_interest: state.interest });
        var first = root.querySelector('[data-step="' + name + '"] button, [data-step="' + name + '"] input, [data-step="' + name + '"] a');
        if (first && name !== 'q1') { try { first.focus({ preventScroll: true }); } catch (e) {} }
      }

      function open() {
        if (!root.hidden) return;
        opener = document.activeElement;
        root.hidden = false;
        go('q1');
        window.requestAnimationFrame(function () { root.classList.add('is-open'); card.focus({ preventScroll: true }); });
        ssSet(SEEN_KEY, '1');
        track('shown');
      }

      function close(remember) {
        root.classList.remove('is-open');
        if (remember) lsSet(DISMISS_KEY, String(Date.now()));
        window.setTimeout(function () { root.hidden = true; }, 300);
        if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
        track('closed');
      }

      Array.prototype.forEach.call(root.querySelectorAll('[data-nv-wp-close]'), function (el) {
        el.addEventListener('click', function () {
          var onDone = !root.querySelector('[data-step="done"]').hidden;
          close(!onDone);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (root.hidden) return;
        if (e.key === 'Escape') { close(root.querySelector('[data-step="done"]').hidden); return; }
        if (e.key !== 'Tab') return;
        var f = card.querySelectorAll('button:not([disabled]), a[href], input:not([disabled])');
        var vis = Array.prototype.filter.call(f, function (n) { return n.offsetParent !== null; });
        if (!vis.length) return;
        var firstEl = vis[0], lastEl = vis[vis.length - 1];
        if (e.shiftKey && (document.activeElement === firstEl || document.activeElement === card)) { e.preventDefault(); lastEl.focus(); }
        else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-answer]'), function (b) {
        b.addEventListener('click', function () {
          state.interest = b.getAttribute('data-answer');
          Array.prototype.forEach.call(root.querySelectorAll('[data-answer]'), function (o) { o.classList.toggle('is-selected', o === b); });
          track('answer_interest', { nv_wp_interest: state.interest });
          window.setTimeout(function () { if (cfg.q2 && (state.interest === 'laminas' || state.interest === 'extensiones')) { setupQ2(); go('q2'); } else { go('email'); } }, 220);
        });
      });
      Array.prototype.forEach.call(root.querySelectorAll('[data-answer2]'), function (b) {
        b.addEventListener('click', function () {
          var ans = b.getAttribute('data-answer2');
          if (state.interest === 'extensiones') { state.experience = ans; } else { state.lamp = ans; }
          Array.prototype.forEach.call(root.querySelectorAll('[data-answer2]'), function (o) { o.classList.toggle('is-selected', o === b); });
          track(state.interest === 'extensiones' ? 'answer_experience' : 'answer_lamp', { nv_wp_experience: state.experience, nv_wp_lamp: state.lamp });
          var emailText = root.querySelector('[data-step="email"] [data-t="email_text"]');
          if (emailText) {
            var msg = state.interest === 'extensiones' ? tx(ans === 'press_on' ? 'msg_press' : (ans === 'laminas_nooves' ? 'msg_nooves' : 'msg_none')) : '';
            emailText.textContent = (msg ? msg + ' ' : '') + tx('email_text');
          }
          window.setTimeout(function () { go('email'); }, 220);
        });
      });

      function profileProps() {
        var p = { popup_interes: state.interest || 'mirando', popup_idioma: cfg.locale || 'es' };
        if (state.experience) p.popup_experiencia = state.experience;
        if (state.lamp) p.popup_lampara = state.lamp;
        /* La Welcome Series elige el código por InteresPrincipal. Láminas y "solo mirando" reciben el de láminas.
           Extensiones no lo escribe: su rama lee popup_interes. */
        if (state.interest !== 'extensiones' && cfg.interesPrincipalLaminas) p.InteresPrincipal = cfg.interesPrincipalLaminas;
        return p;
      }

      /* País del mercado de la tienda, con el nombre en inglés que usa Klaviyo (Portugal, Spain...). */
      var COUNTRY_EN = { ES: 'Spain', PT: 'Portugal', FR: 'France', DE: 'Germany', IT: 'Italy', GB: 'United Kingdom', IE: 'Ireland', NL: 'Netherlands', BE: 'Belgium', AT: 'Austria', US: 'United States' };
      function profileCountry() {
        var iso = String(cfg.countryIso || '').toUpperCase();
        if (!iso) return '';
        try {
          if (window.Intl && Intl.DisplayNames) { var n = new Intl.DisplayNames(['en'], { type: 'region' }).of(iso); if (n && n !== iso) return n; }
        } catch (e) {}
        return COUNTRY_EN[iso] || '';
      }
      function profileAttrs(email) {
        var a = { email: email, properties: profileProps() };
        var c = profileCountry();
        if (c) a.location = { country: c };
        return a;
      }

      function sendToKlaviyo(email, consent) {
        var headers = { 'content-type': 'application/json', 'revision': '2024-10-15' };
        var profile = { data: { type: 'profile', attributes: profileAttrs(email) } };
        if (consent) {
          return window.fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.company), {
            method: 'POST', headers: headers,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: { custom_source: 'popup_bienvenida', profile: profile },
                relationships: { list: { data: { type: 'list', id: cfg.list } } }
              }
            })
          });
        }
        return window.fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(cfg.company), {
          method: 'POST', headers: headers,
          body: JSON.stringify({ data: { type: 'profile', attributes: profileAttrs(email) } })
        });
      }

      function showDone(consent, status) {
        var key = state.interest === 'extensiones' ? 'extensiones' : 'laminas';
        var code = cfg.codes[key] || '';
        var target = cfg.urls[key] || cfg.rootUrl || '/';
        root.querySelector('[data-nv-wp-code]').textContent = code;
        root.querySelector('[data-nv-wp-done-text]').textContent = tx(consent ? (status ? 'done_failed' : 'done_consent') : 'done_noconsent');
        var cta = root.querySelector('[data-nv-wp-cta]');
        cta.textContent = tx(key === 'extensiones' ? 'cta_ext' : 'cta_laminas');
        var base = (cfg.rootUrl || '/');
        if (base.charAt(base.length - 1) !== '/') base += '/';
        cta.setAttribute('href', code ? base + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(target) : target);
        go('done');
        track('code_shown', { nv_wp_interest: state.interest });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var email = form.elements.email.value.trim();
          var consent = form.elements.consent.checked;
          var btn = root.querySelector('[data-nv-wp-submit]');
          err.textContent = '';
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
            err.textContent = tx('err_email');
            form.elements.email.focus();
            return;
          }
          btn.disabled = true;
          btn.textContent = tx('sending');
          function resetBtn() { btn.disabled = false; btn.textContent = tx('submit'); }
          function finish(status) {
            lsSet(DONE_KEY, '1');
            track(status ? 'submit_failed' : 'submitted', { nv_wp_consent: consent ? 'yes' : 'no', nv_wp_interest: state.interest, nv_wp_status: status || 'ok' });
            try { showDone(consent, status); } catch (e2) { err.textContent = tx('err_net'); resetBtn(); }
          }
          function failed(status) {
            try { window.console && console.warn('[nv-wp] Klaviyo no confirmó la suscripción (' + status + ')'); } catch (e3) {}
            if (cfg.showCodeOnError) { finish(String(status)); } else { err.textContent = tx('err_net'); resetBtn(); }
          }
          sendToKlaviyo(email, consent).then(function (r) {
            if (r.ok || r.status === 202) { finish(''); return; }
            return r.text().then(function (t) {
              if (r.status === 400 && /email/i.test(t || '')) { err.textContent = tx('err_email'); resetBtn(); return; }
              failed(r.status);
            }, function () { failed(r.status); });
          }).catch(function () { failed('red'); });
        });
      }

      var copyBtn = root.querySelector('[data-nv-wp-copy]');
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var code = root.querySelector('[data-nv-wp-code]').textContent;
          function ok() { copyBtn.textContent = tx('copied'); window.setTimeout(function () { copyBtn.textContent = tx('copy'); }, 1800); }
          try {
            if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(ok, function () {}); }
          } catch (e) {}
        });
      }

      /* Reglas de aparición */
      function suppressed() {
        var last = parseInt(lsGet(DISMISS_KEY) || '0', 10);
        if (last && Date.now() - last < (cfg.dismissDays || 14) * 86400000) return true;
        if (lsGet(DONE_KEY)) return true;
        if (ssGet(SEEN_KEY)) return true;
        if (klaviyoKnowsEmail()) return true;
        var ex = (cfg.exclude || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        if (cfg.templateSuffix && ex.indexOf(cfg.templateSuffix) > -1) return true;
        return false;
      }

      if (forced) { window.setTimeout(open, 600); return; }
      if (suppressed()) return;

      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var delay = (mobile ? cfg.delayMobile : cfg.delayDesktop) * 1000;
      var scrollPct = mobile ? cfg.scrollMobile : cfg.scrollDesktop;
      var fired = false;
      var waited = 0;
      var polling = false;
      function waitTick() {
        waited += 1;
        if (fired || waited > 90) return;
        if (blocked()) { window.setTimeout(waitTick, 1000); return; }
        polling = false;
        fire();
      }
      function blocked() {
        if (cfg.templateName === 'cart') return true;
        var cart = document.querySelector('.NooCart.is-open');
        if (cart) return true;
        var ck = document.querySelector('.cc-window, .pandectes-banner');
        if (ck && !/cc-invisible|cc-hide/.test(ck.className) && ck.offsetHeight > 0) return true;
        var sp = document.getElementById('shopify-pc__banner');
        if (sp && sp.offsetHeight > 0) return true;
        return false;
      }
      function fire() {
        if (fired) return;
        if (blocked()) {
          if (!polling) { polling = true; waitTick(); }
          return;
        }
        fired = true;
        window.removeEventListener('scroll', onScroll);
        open();
      }
      function onScroll() {
        var doc = document.documentElement;
        var max = doc.scrollHeight - window.innerHeight;
        if (max > 0 && (window.scrollY / max) * 100 >= scrollPct) fire();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.setTimeout(fire, delay);
    }

    function boot() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-nv-wp]'), init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
